import { AdditionalConditionCard } from './AdditionalConditionCard';
import {
  ADDITIONAL_CONDITION_STATES,
  type AdditionalConditionItem,
} from './types';

export type AdditionalConditionCardsProps = {
  conditions: AdditionalConditionItem[];
};

const STATE_ORDER: Record<
  (typeof ADDITIONAL_CONDITION_STATES)[keyof typeof ADDITIONAL_CONDITION_STATES],
  number
> = {
  [ADDITIONAL_CONDITION_STATES.AVAILABLE_FOR_REFILL]: 0,
  [ADDITIONAL_CONDITION_STATES.PRESCRIPTION_ISSUED]: 1,
  [ADDITIONAL_CONDITION_STATES.REQUEST_SUBMITTED]: 2,
  [ADDITIONAL_CONDITION_STATES.AVAILABLE]: 3,
  [ADDITIONAL_CONDITION_STATES.LOCKED]: 4,
  [ADDITIONAL_CONDITION_STATES.LOCKED_BEFORE_CONSULT]: 4,
  [ADDITIONAL_CONDITION_STATES.LOCKED_WAITING_REFILL]: 4,
};

/**
 * The list of Additional Treatment cards on their own — sorted by state
 * priority. Reusable outside the `AdditionalConditionsList` "Expanded Care"
 * container (e.g. on the prep-seq landing page).
 */
export const AdditionalConditionCards = ({
  conditions,
}: AdditionalConditionCardsProps) => {
  if (conditions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-xs">
      {[...conditions]
        .sort((a, b) => STATE_ORDER[a.state] - STATE_ORDER[b.state])
        .map((condition) => (
          <AdditionalConditionCard key={condition.id} condition={condition} />
        ))}
    </div>
  );
};
